export default "__VITE_ASSET__D0hwTWe5__"